import './Welcome.css';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAccessToken, getAccessTokenFromUrl } from './spotify';

function Welcome() {
  const navigate = useNavigate();
  const [accessToken, setAccessToken] = useState(null);
  const clientID = process.env.REACT_APP_SPOTIFY_CLIENT_ID;
  const redirectURI = `${window.location.origin}/callback`;

  useEffect(() => { 
    const token = getAccessTokenFromUrl();
    if (token) {
      setAccessToken(token);
      window.history.replaceState({}, document.title, "/welcome"); 
    }
  }, []);

  const handleSpotifyAuth = () => {
    getAccessToken(clientID, redirectURI);
  };

  const handleStart = () => {
    navigate('/app', { state: { accessToken } });
  };

  return (
    <div className="welcomes">
    <div className="welcome-page">
      <img src="/Capture.webp" alt="Capture" className="welcome-image" />
      <h1>Welcome to Trip Tunes</h1>
      <p>Get started by authenticating with Spotify and then Continue.</p>
      {!accessToken && <button onClick={handleSpotifyAuth}>Authenticate with Spotify</button>}
      {accessToken && <button onClick={handleStart}>Continue</button>}
    </div>
    </div>
  );
}

export default Welcome;